import { useQuery } from "@tanstack/react-query"
import { getBackofficeOrganizationCreditsQuery } from "modules/backoffice/lib/organizations/getBackofficeOrganizationCreditsQuery"

export function useGetBackofficeOrganizationCreditsQuery(
  ...args: Parameters<typeof getBackofficeOrganizationCreditsQuery>
) {
  return useQuery(getBackofficeOrganizationCreditsQuery(...args))
}
